"use client";

import React, { Suspense } from "react";
import { SessionProvider } from "next-auth/react";
import { NuqsAdapter } from "nuqs/adapters/next/app";

import { TRPCReactProvider } from "~/trpc/react";
import { TooltipProvider } from "~/components/ui/tooltip";
import ConsentBasedScripts from "../consent-based-scripts";
import { MetaPageView } from "../meta-page-view";
import { PostHogAppProvider } from "./posthog";
import type { ConsentState } from "~/lib/consent-region";
import { InitialDiscountProvider } from "~/components/providers/initial-discount-provider";

const Providers = ({
  children,
  initialConsent,
}: {
  children: React.ReactNode;
  initialConsent: ConsentState;
}) => {
  return (
    <TRPCReactProvider>
      <SessionProvider>
        <ConsentBasedScripts initialConsent={initialConsent} />
        <Suspense fallback={null}>
          <PostHogAppProvider initialConsent={initialConsent} />
        </Suspense>
        <Suspense fallback={null}>
          <MetaPageView />
        </Suspense>
        <TooltipProvider>
          <NuqsAdapter>
            <InitialDiscountProvider
              initialDiscountCode={null}
              initialHydrated={false}
            >
              {children}
            </InitialDiscountProvider>
          </NuqsAdapter>
        </TooltipProvider>
      </SessionProvider>
    </TRPCReactProvider>
  );
};

export default Providers;
